import { useSubscription } from '@apollo/client';
import { CHAT_TITLE_UPDATED } from '../graphql/subscriptions';
import { useChatStore } from '../stores/chatStore';

interface ChatTitleUpdate {
  title: string;
  messageId: string;
}

/**
 * Hook for subscribing to chat title updates
 */
export function useChatTitleSubscription() {
  const { setTitleForMessage } = useChatStore();

  const { error } = useSubscription<{ chatTitleUpdated: ChatTitleUpdate }>(CHAT_TITLE_UPDATED, {
    onData: ({ data }) => {
      if (data?.data?.chatTitleUpdated) {
        const { title, messageId } = data.data.chatTitleUpdated;
        setTitleForMessage(title, messageId);
      }
    },
    onError: (error) => {
      console.error('Chat title subscription error:', error);
    },
  });

  return { error };
}
